// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__25Jy5","question":"Question_question__2Fhyt","description":"Question_description__pPWbg"};